import { connect } from 'react-redux';
import UnbookableSection from './UnbookableSection';
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';

export default connect(mapStateToProps, mapDispatchToProps)(UnbookableSection);
